module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-button-group"
  }, [_vm._t("default"), _vm._v(" "), (_vm.$slots.more) ? _c('div', {
    staticClass: "button-group-more"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "slot": "more",
      "trigger": "hover",
      "popper-class": "rtElPopover"
    },
    slot: "more"
  }, [_c('div', {
    staticClass: "rt-button-more",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('rt-button', {
    attrs: {
      "icon-name": "rt-base-more"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rt-button-group-popper-wrapper"
  }, [_vm._t("more")], 2)])], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee957320"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/button/rtButtonGroup.vue
// module id = 1551
// module chunks = 91